//key used to get the JWT token from local storage
export const authTokenKey = 'jwtKey';
//size in pixels of one table row
export const tableCellHeight = 46;
//the amount of extra items to load on the first time we display a list
export const itemBufferCount = 10;
